define('app-InlineValidation/main',['./settings', 'underscore', '../libs/jquery-Plugins/inlineValidation'], function (settings, _) {
    return {
        run: function () {
            _.each($(settings.container), function (container) {
                $(container).find('input, select').watchIsValid();

                $(container).find('input[type="submit"]').click(function () {
                    var list = $(container).find('input,select').filter('[required]').not('.buttonclass').filter(":visible");

                    $.each(list, function() {
                        $(this).checkIsValid();
                    });

                    if ($(container).find('input[aria-invalid="true"]').length > 0) {
                        var position = $(container).find('input[aria-invalid="true"]').first()[0].getBoundingClientRect().top;
                        window.scrollTo(0, position);
                        return false;
                    }
                });

                $(container).find('a.address-search').click(function () {
                    $(container).find('input.postcodesearch').checkIsValid();
                    //check whether the regex is fired or the html validation fired
                    if (($(container).find('span.regexinvalidpostcode').is(":visible"))
                        || ($(container).find('span.reqinvalidpostcode').is(":visible"))
                        || ($(container).find('input.postcodesearch').attr('aria-invalid'))) {
                        $('#SearchLoader').css('display', 'none');
                        return;
                    }
                });

                $(".ShadowBox").hide();

                $('a.button-manual').click(function () {
                    $(".ShadowBox").show();
                });
            });
        }
    }
});
